import React from "react";
import {
  Card, CardContent, Grid, ButtonGroup, Button, Divider,
  Chip, IconButton, Tooltip, Typography
} from "@material-ui/core";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ClearIcon from "@material-ui/icons/Clear";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { format as formatDate } from "date-fns";

const parseInputDate = (value) => (value ? new Date(`${value}T00:00:00`) : null);
const formatForInput = (date) =>
  date instanceof Date && !Number.isNaN(date?.getTime()) ? formatDate(date, "yyyy-MM-dd") : "";

export default function FiltersBar({
  mode, setMode,
  accrualField, setAccrualField,
  rangePreset, setRangePreset,           // '30d' | '90d' | 'ytd'
  useCustom, setUseCustom,
  fromCustom, setFromCustom,
  toCustom, setToCustom,
  grouping, setGrouping,                 // 'day' | 'week' | 'month'
}) {
  const toggleChip = (label) => {
    return null;
  };

  const clearCustom = () => { setUseCustom(false); setFromCustom(""); setToCustom(""); };

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container spacing={2} alignItems="center" justify="space-between">
          <Grid item>
            <ButtonGroup size="small" variant="outlined">
              <Button disabled>Cash</Button>
              <Button variant="contained">Accrual</Button>
            </ButtonGroup>
          </Grid>

          <Grid item style={{ flex: 1 }}>
            <Grid container spacing={1} alignItems="center" justify="flex-end">
              <Grid item>
                <ButtonGroup size="small" variant="outlined" disabled={useCustom}>
                  <Button onClick={() => setRangePreset("30d")} variant={!useCustom && rangePreset === "30d" ? "contained" : "outlined"}>30d</Button>
                  <Button onClick={() => setRangePreset("90d")} variant={!useCustom && rangePreset === "90d" ? "contained" : "outlined"}>90d</Button>
                  <Button onClick={() => setRangePreset("ytd")} variant={!useCustom && rangePreset === "ytd" ? "contained" : "outlined"}>YTD</Button>
                </ButtonGroup>
              </Grid>

              <Grid item>
                <Divider orientation="vertical" style={{ height: 28 }} />
              </Grid>

              <Grid item>
                <ButtonGroup size="small" variant="outlined">
                  <Button onClick={() => setGrouping("day")} variant={grouping === "day" ? "contained" : "outlined"}>Day</Button>
                  <Button onClick={() => setGrouping("week")} variant={grouping === "week" ? "contained" : "outlined"}>Week</Button>
                  <Button onClick={() => setGrouping("month")} variant={grouping === "month" ? "contained" : "outlined"}>Month</Button>
                </ButtonGroup>
              </Grid>

              <Grid item>
                <Tooltip title={useCustom ? "Using custom range" : "Use custom range"}>
                  <IconButton color={useCustom ? "primary" : "default"} onClick={() => setUseCustom(v => !v)} size="small">
                    <CalendarTodayIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Grid>

              <Grid item>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    margin="dense"
                    label="From"
                    value={parseInputDate(fromCustom)}
                    onChange={(date) => {
                      setUseCustom(true);
                      setFromCustom(formatForInput(date));
                    }}
                    disabled={!useCustom}
                    KeyboardButtonProps={{ "aria-label": "change start date" }}
                    size="small"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item>
                <Typography variant="body2">to</Typography>
              </Grid>
              <Grid item>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    margin="dense"
                    label="To"
                    value={parseInputDate(toCustom)}
                    onChange={(date) => {
                      setUseCustom(true);
                      setToCustom(formatForInput(date));
                    }}
                    disabled={!useCustom}
                    KeyboardButtonProps={{ "aria-label": "change end date" }}
                    size="small"
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              {useCustom && (
                <Grid item>
                  <Tooltip title="Clear custom range">
                    <IconButton onClick={clearCustom} size="small">
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              )}

              <Grid item>
                <Divider orientation="vertical" style={{ height: 28 }} />
              </Grid>

            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
